import FormConfig from "../formConfig.js";
import { Loading } from "element-ui";
import { fun_PostAction, fun_GetAction, fun_UploadImg } from "@/api/index";
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import CandidateChoose from "../../components/candidateChoose/index.vue";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 默认展开全部面板
      activeNames: [],
      // 展开全部面板
      activeName: ["1", "2", "3", "4", "5"],
      // 中标项目基本信息
      winningPublicity: {
        id: null, // 中标公示编号
        constructionPrjName: null, // 报建项目名称
        constructionNo: null, // 报建编号
        prjName: null, // 招标项目名称
        tenderReference: null, // 招标编码
        section: null, // 标段号
        tenderContent: null, // 招标内容
        tenderTypeName: null, // 招标方式
        tenderClassName: null, // 招标类别
        reserveStartTime: null, // 开标时间
        openingPlace: null, // 开标地点
        evaluationStartDate: null, // 评标时间
        reviewAdd: null, // 评标地点
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        evaluationMethod: null, // 评标办法
        isAudit: null, // 是否核验
        regulators: null, // 行政监督部门
        tenderCorpId: null // 招标人编号
      },
      // 放弃中标候选人信息
      winningCandidate: {
        basicInfoId: null, // 中标候选人编号
        basicInfoName: null, // 中标候选人
        winningPrice: null, // 中标价（万元）
        winningRanking: null, // 中标名次
        qualityStandard: null, // 质量标准
        winningLimit: null, // 中标工期（日历天）
        securityCivilizationFee: null, // 安全防护、文明施工及环境保护费
        giveUpExplain: null // 放弃中标说明
      },
      // 重定中标/重新招标信息
      winningAbandon: {
        id: null, // 主键
        publicityNumber: null, // 中标公示编号
        basicInfoName: null, // 中标候选人名称
        bidNumber: null, // 中标候选人编号
        supplement: null, // 是否递补
        abandonBidExplain: null, // 重定候选人说明
        picturePath: null, // 图片路径
        pictureName: null, // 图片名称
        pictureinforId: null, // 投标图片信息存放表主键
        state: null, // 状态
        type: null, // 类型
        tableName: null, // 表名
        keyState: null, // 字段
        tenderReference: null, // 招标编号
        tenderOpinion: null, // 招标人意见
        digitalSignature: null, // 数字签名
        lockNo: null // 锁编号
      },
      // 重定中标/重新招标操作错误信息
      error: {
        basicInfoName: null, // 中标候选人选择
        abandonBidExplain: null // 重新招标说明
      },
      // 保证金信息
      boundData: {
        bidCorpName: null, // 企业名称
        refundWay: null, // 退款方式
        refundReason: null, // 退款原因
        refundDescription: null, // 退款说明
        retFlag: null, // 退还标志
        retFlagReason: null, // 不退还理由
        conSeqNo: null, // 来账确认编号
        refundState: null, // 退款状态
        refundId: null, // 退还编号
        oprFlag: null // 操作类型
      },
      // 错误信息
      boundError: {
        bidCorpName: null, // 企业名称
        refundWay: null, // 退款方式
        refundReason: null, // 退款原因
        refundDescription: null, // 退款说明
        retFlag: null, // 退还标志
        retFlagReason: null, // 不退还理由
        conSeqNo: null, // 来账确认编号
        refundState: null, // 退款状态
        refundId: null, // 退还编号
        oprFlag: null // 操作类型
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 中标公示编号
      publicityNumber: null,
      // 操作标识
      controllerFlag: null,
      // 标志
      flag: null,
      // 放弃中标单位编号
      winAbdBasicInfoId: null,
      // 是否甲方确认
      isTenderSignature: null,
      // 是否显示保证金
      bidBound: null,
      // 参数对象
      obj: {},
      // 不退还申请表模板路径
      url: null,
      // 文件
      fileList: [],
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 一览传递判断状态图片
      stateObj: {
        tenderSignedId: null,
        tenderSignedState: null,
        state: null
      }
    };
  },
  // 注册组件
  components: {
    CaLock,
    AuditHistoryRecord,
    CandidateChoose
  },

  // 模板编译完成
  mounted() {
    // 主键
    this.id = this.$route.query.id;
    // 操作标识
    this.controllerFlag = this.$route.query.controllerFlag;
    // 中标公示编号
    this.publicityNumber = this.$route.query.publicityNumber;
    // 标志
    this.flag = this.$route.query.flag;
    // 是否甲方确认
    this.isTenderSignature = this.$route.query.isTenderSignature;
    // 获取一览传递用于判断状态图片
    this.stateObj.tenderSignedId = this.$route.query.tenderSignedId;
    this.stateObj.tenderSignedState = this.$route.query.tenderSignedState;
    this.stateObj.state = this.$route.query.state;
    // 默认展开全部面板
    this.activeNames = this.formConfigList.map(item => {
      return item.name;
    });
    // 请求详情
    this.fun_Details();
    // 获取不退还申请表路径
    this.fun_GetFileUrl();
  },

  // 自定义方法
  methods: {
    /**
     * 请求详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/winningCandidate/detail", {
        id: this.id,
        publicityNumber: this.publicityNumber,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断是否请求成功
        if (result) {
          // 中标项目基本信息
          this.winningPublicity = data.winningPublicity;
          // 中标候选人信息
          this.winningCandidate = data.winningCandidate;
          // 存在重定标信息
          if (data.winningAbandon) {
            // 重定中标或废标信息
            this.winningAbandon = data.winningAbandon;
          }
          // 放弃中标单位编号
          this.winAbdBasicInfoId = data.winAbdBasicInfoId;
          // 是否显示保证金
          this.bidBound = data.bidBound;
          // 保证金信息
          this.boundData = data.boundData;
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 处理对象数据（删除空值的字段）
          this.winningPublicity = this.fun_DeleteNull(this.winningPublicity);
          // 处理对象数据（删除空值的字段）
          this.winningCandidate = this.fun_DeleteNull(this.winningCandidate);
          // 存入对象
          this.obj = { ...this.winningCandidate, ...this.winningPublicity };
        }
      });
    },

    /**
     * 删除空值的字段
     * @author shuhua
     */
    fun_DeleteNull(obj) {
      // 遍历数据
      for (var i in obj) {
        // 判断是否有值
        if (!obj[i] && obj[i] !== 0) {
          // 删除数据
          delete obj[i];
        }
      }
      // 返回
      return obj;
    },

    /**
     * 中标候选人选择
     * @author shuhua
     */
    fun_CandidateChoose() {
      // 查询标志
      this.$refs.candidateChoose.flag = "wfq";
      // 评标办法
      this.$refs.candidateChoose.evaluationMethod = this.winningPublicity.evaluationMethod;
      // 中标公示编号
      this.$refs.candidateChoose.publicityNumber = this.winningPublicity.id;
      // 打开弹窗
      this.$refs.candidateChoose.dialogVisible = true;
      // 获取一览
      this.$refs.candidateChoose.fun_GetList();
    },

    /**
     * 中标候选人选择赋值
     * @author shuhua
     */
    fun_SetBidNum(e) {
      // 中标人名称
      this.winningAbandon.basicInfoName = e.corpName;
      // 中标人编号
      this.winningAbandon.bidNumber = e.basicInfoId;
    },

    /**
     * 行政监督部门下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeRegulators(e) {
      // 赋值
      this.winningPublicity.regulators = e.code;
    },

    /**
     * 是否退还给招标人下拉框值改变事件
     */
    fun_ChangeRetFlag(e) {
      // 赋值
      this.boundData.retFlag = e.code;
    },

    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },

    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_CalibrationInvalidInsUpd(state) {
      // 验证 // 重定中标/重新招标操作
      this.$refs.winningAbandonForm.validate(valid => {
        // 验证通过
        if (valid) {
          // 显示保证金
          if (this.bidBound === "0") {
            // 验证 未退还保证金单位
            this.$refs.boundForm.validate(valid => {
              // 验证通过
              if (valid) {
                // 退还保证金提交
                this.fun_TenderBondInsUpd(state);
              }
            });
          } else {
            // 退还保证金提交
            this.fun_TenderBondInsUpd(state);
          }
        }
      });
    },

    /**
     * 退还保证金提交
     * @author shuhua
     */
    fun_TenderBondInsUpd(state) {
      // 操作状态
      this.winningAbandon.state = state;
      // 提交
      if (this.winningAbandon.state === "tj") {
        // 说明为空
        if (!this.winningAbandon.abandonBidExplain) {
          // 错误消息提示
          this.$alert("说明必须填写！", "warning");
          return;
        }
      }
      // 显示保证金
      if (this.winningAbandon.bidBound === "0") {
        // 参数
        var parameters = new Array();
        // 招标编号
        parameters[0] = this.winningAbandon.tenderReference;
        // 第一名
        parameters[1] = "";
        //招标人ID
        var bidAccountBasicInfoId = this.winningPublicity.tenderCorpId;
        //投标人ID
        var accountBasicInfoId = this.winningCandidate.basicInfoId;
        //选择为退还时,退还给招标人
        if (this.boundData.retFlag == "0") {
          // 退还至招标人
          parameters[2] = bidAccountBasicInfoId;
          // 投标单位编号
          parameters[3] = "";
        } else if (this.boundData.retFlag == "1") {
          // 退还至投标人
          parameters[2] = "";
          // 投标单位编号
          parameters[3] = accountBasicInfoId;
        }
        parameters[4] = "1";
        // 检查投标单位基本户
        this.fun_CheckBasicAccount(parameters);
      } else {
        // 如果是提交
        if (this.winningAbandon.state == "tj") {
          // 开启弹窗
          this.$refs.caLock.dialogCalock = true;
          // 签名数据
          this.$refs.caLock.data =
            this.winningAbandon.tenderReference +
            this.winningPublicity.prjName +
            this.winningPublicity.section;
          // 状态
          this.$refs.caLock.state = state;
        }
        // 如果是保存
        else {
          // 提交的方法
          this.fun_Submit();
        }
      }
    },

    /**
     * 检查投标单位基本户
     * @author shuhua
     */
    fun_CheckBasicAccount(parameters) {
      // 发起请求
      fun_PostAction("/winningPublicity/checkBasicAccount", {
        parameters: parameters
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 招标人基本户信息未核验通过
          if (data.tenderAccount === false) {
            // 错误提示
            this.$alert(data.msg, "warning");
            return;
          }
          // 投标单位基本户信息未核验通过
          if (data.account === false) {
            // 询问框
            this.$confirm(data.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              // 如果是提交
              if (this.winningAbandon.state == "tj") {
                // 开启弹窗
                this.$refs.caLock.dialogCalock = true;
                // 签名数据
                this.$refs.caLock.data =
                  this.winningAbandon.tenderReference +
                  this.winningPublicity.prjName +
                  this.winningPublicity.section;
                // 状态
                this.$refs.caLock.state = state;
              }
              // 如果是保存
              else {
                // 提交的方法
                this.fun_Submit();
              }
            });
          } else {
            // 如果是提交
            if (this.winningAbandon.state == "tj") {
              // 开启弹窗
              this.$refs.caLock.dialogCalock = true;
              // 签名数据
              this.$refs.caLock.data =
                this.winningAbandon.tenderReference +
                this.winningPublicity.prjName +
                this.winningPublicity.section;
              // 状态
              this.$refs.caLock.state = state;
            }
            // 如果是保存
            else {
              // 提交的方法
              this.fun_Submit();
            }
          }
        }
      });
    },

    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.winningAbandon.lockNo = lockNo;
      // 赋值数字签名
      this.winningAbandon.digitalSignature = digitalSignature;
      // 操作状态
      this.winningAbandon.state = state;
      // 提交的方法
      this.fun_Submit();
    },

    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit() {
      // 表单
      var formData = new FormData();
      // 中标项目信息
      formData.append(
        "winningPublicity",
        JSON.stringify(this.winningPublicity)
      );
      // 放弃中标候选人信息
      formData.append(
        "winningCandidate",
        JSON.stringify(this.winningCandidate)
      );
      // 重定标信息
      formData.append("winningAbandon", JSON.stringify(this.winningAbandon));
      // 未退还保证金信息
      formData.append("boundData", JSON.stringify(this.boundData));
      // 上传附件不为空
      if (this.fileList.length > 0) {
        // 退还保证金附件
        formData.append("file", this.fileList[0].raw);
      }
      // 是否显示保证金
      formData.append("bidBound", this.bidBound);
      // 操作标识（0则是重定招标人 1则为废标）
      formData.append("flag", this.flag);
      // 加载框
      this.fun_Loading();
      // 发起请求
      fun_UploadImg("/winningCandidate/saveOrUpdate", formData, 0).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 关闭遮罩
          this.fullLoading.close();
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 关闭遮罩
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },

    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      // 招标人意见不为空
      if (data.tenderOpinion) {
        // 赋值
        this.winningAbandon.tenderOpinion = data.tenderOpinion;
        // 赋值
        this.tenderSignedForm.tenderOpinion = data.tenderOpinion;
      }
      // 招标人签章确认编号不为空
      if (data.tenderSignedId) {
        // 赋值
        this.tenderSignedForm.tenderSignedId = data.tenderSignedId;
      }
      // 招标人签章状态不为空
      if (data.tenderSignedState) {
        // 赋值
        this.tenderSignedForm.tenderSignedState = data.tenderSignedState;
      }
      // 添加标记不为空
      if (data.isDeregulation) {
        // 赋值
        this.tenderSignedForm.isDeregulation = data.isDeregulation;
      }
      // 招标人盖章确认的招标监管部门不为空
      if (data.esRegulators) {
        // 赋值
        this.tenderSignedForm.esRegulators = data.esRegulators;
      }
      //  招标人盖章确认的招标监管流程不为空
      if (data.esProcessType) {
        // 赋值
        this.tenderSignedForm.esProcessType = data.esProcessType;
      }
      // 招标人盖章确认权限编号不为空
      if (data.esInvitationId) {
        // 赋值
        this.tenderSignedForm.esInvitationId = data.esInvitationId;
      }
      // 招标人盖章的数字签名不为空
      if (data.tenderStampData) {
        // 赋值
        this.tenderSignedForm.tenderStampData = data.tenderStampData;
      }
      // 重定中标信息不为空
      if (data.winningAbandon) {
        // 表名
        this.tenderSignedForm.table = data.winningAbandon.tableName;
        // 字段
        this.tenderSignedForm.key = data.winningAbandon.keyState;
        // 数据编号
        this.tenderSignedForm.recordNumber = data.winningAbandon.id;
      }
    },

    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 提交
      if (this.winningAbandon.state === "tj") {
        // 说明为空
        if (!this.winningAbandon.abandonBidExplain) {
          // 错误消息提示
          this.$alert("说明必须填写！", "warning");
          return;
        }
      }
      // 如果招标人意见不为空
      if (
        this.winningAbandon.tenderOpinion != "" &&
        this.winningAbandon.tenderOpinion != null
      ) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.winningAbandon.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.winningAbandon.prjName +
        this.tenderSignedForm.tenderStampData +
        this.winningAbandon.publishFlag;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },

    /**
     * 上传文件
     */
    fun_FileChange(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      // 这里限定上传文件文件类型必须为jpg，gif或png，如果文件类型不符，提示错误信息
      if (suffix == "jpg" || suffix == "gif" || suffix == "png") {
        if (fileList.length === 1) {
          this.fileList = fileList;
        }
        if (fileList.length > 1) {
          const list = fileList.pop();
          this.fileList = [list];
        }
      } else {
        // 清除文件
        this.$refs.fileUpload.clearFiles();
        // 提示错误消息
        this.$message.error("图片格式有误，请上传jpg或gif或png格式的图片");
        // 返回
        return false;
      }
    },

    /**
     * 移除文件
     * @author shuhua
     */
    handleRemove(file) {
      // 文件集合为空
      this.fileList = [];
    },

    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },

    /**
     * 获取文件模板路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "不退还申请表"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 不退还申请表路径
          this.url = data;
        }
      });
    },

    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },

    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    }
  }
};
